import React from "react";
import "../styles/About.css";
import { FaHtml5, FaCss3Alt, FaJs, FaPython, FaDatabase, FaReact, FaChartBar, FaLaptopCode } from "react-icons/fa";

export default function About() {
  return (
    <section id="about">
      <div className="card about-card">
        <h2>About Me</h2>
        <p>
          Hi! I’m <strong>Sai Bairavan</strong>, a tech enthusiast and aspiring Frontend Developer with a strong interest in AI, Data Science, Web Development, and Data Analytics. 
          Currently pursuing B.Tech in AI & Data Science at S.A Engineering College (2023 – 2027) with a solid academic record, I love building interactive web experiences, exploring data-driven solutions, and contributing to innovative projects. 
          I’m eager to grow through internships where I can apply my skills, learn from real-world challenges, and make an impact.
        </p>
      </div>

      <div className="card education-card">
        <h3>Education</h3>
        <ul>
          <li>B.Tech (AI & DS), S.A Engineering College | 2023 – 2027 | Aggregate: 8.9</li>
          <li>HSC, Sri Saraswathi Vidhya Mandir MHSS | 2022 – 2023 | Aggregate: 81%</li>
          <li>SSLC, Sri Saraswathi Vidhya Mandir MHSS | 2020 – 2021</li>
        </ul>
      </div>

      <div className="card languages-card">
        <h3>Languages</h3>
        <p>English, Tamil</p>
      </div>

      <div className="card skills-card">
        <h3>Skills</h3>
        <div className="skills-icons">
          <div className="skill"><FaHtml5 color="#e34c26" /> HTML</div>
          <div className="skill"><FaCss3Alt color="#264de4" /> CSS</div>
          <div className="skill"><FaJs color="#f7df1e" /> JavaScript</div>
          <div className="skill"><FaPython color="#3776ab" /> Python</div>
          <div className="skill"><FaDatabase color="#f29111" /> SQL</div>
          <div className="skill"><FaReact color="#61dbfb" /> React.js</div>
          <div className="skill"><FaChartBar color="#f2c80f" /> Power BI</div>
          <div className="skill"><FaLaptopCode color="#6e5494" /> UI/UX Design</div>
        </div>
      </div>

      <div className="card courses-card">
        <h3>Courses</h3>
        <ul>
          <li>Full Stack Developer, Nxtwave (2024 – present)</li>
          <li>Excel, Coursera</li>
        </ul>
      </div>
    </section>
  );
}
